import moment from "moment";

const generateRowIndex = (data) => {
  return data.map((item, index) => ({ ...item, rowIndex: index + 1 }));
};

const generateMonths = (year, prop = "") => {
  const months = [];

  for (let i = 0; i < 12; i++) {
    const monthDate = new Date(year, i);
    const monthLabel = moment(monthDate).format(prop);

    months.push({
      value: i,
      label: monthLabel
    });
  }

  return months;
};

const generateYears = (year, total, prop = "") => {
  const years = [];

  for (let i = 0; i < total; i++) {
    const yearDate = new Date(`${year - i}`);
    const yearLabel = moment(yearDate).format(prop);

    years.push({
      value: year - i,
      label: yearLabel
    });
  }

  return years;
};

export { generateRowIndex, generateMonths, generateYears };
